(function () {
    'use strict';

    function wizardSearch($rootScope, searchDataService, searchService) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/wizardSearch.html',
            scope: {
                searchControlId: '@',
                results: '=',
                searchConfiguration: '=',
                sessionData: '=',
                showResults: '=',
                attributes: '=',
                presetAttributes: '=',
                returnToWizardPrompt: '@',
                isHidden: '=?',
                additionalQueryString: '@?',
                pageSize: '=?',
                pageNum: '=?',
                totalItems: '=?',
                showResultsPrompt: '@?'
            },
            link: function (scope, element, attrs) {
                if (!attrs.searchControlId) {
                    scope.searchControlId = 'searchControlId';
                }

                if (!attrs.returnToWizardPrompt) {
                    scope.returnToWizardPrompt = "Return to wizard";
                }

                if (!attrs.isHidden) {
                    scope.isHidden = false;
                }

                scope.currentWizardStep = 0;

                scope.queryModel = {
                    entity: scope.searchConfiguration.Entity,
                    uri: scope.searchConfiguration.Uri,
                    pageSize: scope.pageSize || 10,
                    pageNum: scope.pageNum || 0,
                    numPages: 0,
                    orderBy: "Name",
                    orderByDirection: "asc",
                    predicates: {},
                    injectedPredicates: scope.searchConfiguration.InjectedSearchCriteria,
                    defaultPredicates: scope.searchConfiguration.DefaultSearchCriteria,
                    isWizardComplete: false
                };

                if (scope.additionalQueryString) {
                    scope.queryModel.additionalQueryString = scope.additionalQueryString;
                }

                scope.searchConfiguration.WizardSteps.forEach(function (item) {
                    scope.queryModel.predicates[item.SearchFieldName] = {
                        value: item.SearchCondition === 'In' ? item.PreselectedValues : item.PreselectedValues.length > 0 ? item.PreselectedValues[0] : null,
                        condition: item.SearchCondition,
                        preselectedValues: item.PreselectedValues,
                        watch: function () { return true; }
                    }
                    item.PreviousStepIndex = 0;

                    item.Options.forEach(function (option) {
                        option.IsSelected = false;
                    });
                });

                scope.lastStepBeforeCompletion = 0;

                scope.pageSizes = [5, 10, 15, 20, 25];

                if (scope.presetAttributes) {
                    scope.presetAttributes.forEach(function (attribute) {
                        scope.queryModel.predicates[attribute.Name].value = attribute.Value;
                    });

                    scope.queryModel.isWizardComplete = true;

                    scope.showResults = true;
                };

                scope.toggleOption = function (stepIndex, optionIndex) {
                    var wizardStep = scope.searchConfiguration.WizardSteps[stepIndex];
                    var previousStepPredicate = scope.searchConfiguration.WizardSteps[wizardStep.PreviousStepIndex].predicate;
                    var predicate = scope.queryModel.predicates[wizardStep.SearchFieldName];
                    var optionValue = wizardStep.Options[optionIndex].Value;
                    wizardStep.Options[optionIndex].IsSelected = !(wizardStep.Options[optionIndex].IsSelected);

                    // if we are turning on an option
                    if (wizardStep.Options[optionIndex].IsSelected) {
                        // If its an in, its additive
                        if (predicate.condition === 'In') {
                            if (Array.isArray(predicate.value)) {
                                // add the value to the existing array
                                if (Array.isArray(optionValue)) {
                                    // combine the arrays
                                    predicate.value = predicate.value.concat(optionValue);
                                }
                                else {
                                    // push the new value
                                    predicate.value.push(optionValue);
                                }
                            }
                            else {
                                // make it an array
                                predicate.value = [predicate.value];
                                if (Array.isArray(optionValue)) {
                                    // combine the arrays
                                    predicate.value = predicate.value.concat(optionValue);
                                }
                                else {
                                    // push the new value
                                    predicate.value.push(optionValue);
                                }
                            }
                            // remove duplicates
                            predicate.value = _.uniq(predicate.value);
                        }
                            // otherwise, just replace the value
                        else {
                            predicate.value = optionValue;
                        }
                    }
                        // if we are turning off an option
                    else {
                        if (predicate.condition === 'In') {
                            // it should always be an array
                            if (!Array.isArray(predicate.value)) {
                                predicate.value = [predicate.value];
                            }

                            // we need to preserve the previous step's state
                            if (Array.isArray(optionValue)) {
                                // only remove the items that are not in the previous step's values if the predicates are the same name
                                if (previousStepPredicate && previousStepPredicate.fieldName === wizardStep.SearchFieldName) {
                                    optionValue.forEach(function (optVal) {
                                        var indexOfItemToRemove = predicate.value.indexOf(optVal);
                                        var previousStepValIndex = previousStepPredicate.details.value.indexOf(optVal);
                                        if (previousStepValIndex === -1) {
                                            predicate.value.splice(indexOfItemToRemove, 1);
                                        }
                                    });
                                } else {
                                    // remove the value
                                    predicate.value = _.difference(predicate.value, optionValue);
                                }
                            } else {
                                // just remove that one value if it doesnt already exist
                                if (previousStepPredicate && previousStepPredicate.fieldName === wizardStep.SearchFieldName) {
                                    var valueIndex = previousStepPredicate.details.value.indexOf(optionValue);
                                    if (valueIndex === -1) {
                                        predicate.value.splice(valueIndex, 1);
                                    }
                                } else {
                                    // remove the value
                                    var indexOfItemToRemove = predicate.value.indexOf(optionValue);
                                    predicate.value.splice(indexOfItemToRemove, 1);
                                }
                            }
                        }
                        else {
                            predicate.value = null;
                        }
                    }

                    // this will come later with multi select options in wizards
                    //if (Array.isArray(predicate.value)) {
                    //    if (wizardStep.IsMultiSelect) {
                    //        if (Array.isArray(optionValue)) {
                    //            predicate.value = _.intersection(predicate.value, optionValue).length > 0
                    //                ? _.difference(predicate.value, optionValue)
                    //                : predicate.value.concat(optionValue);
                    //        }
                    //        else {
                    //            var optionValueIndex = predicate.value.indexOf(optionValue);
                    //            if (optionValueIndex === -1) {
                    //                predicate.value.push(optionValue);
                    //            } else {
                    //                predicate.value.splice(optionValueIndex, 1);
                    //            }
                    //        }
                    //    }
                    //    else {
                    //        if (Array.isArray(optionValue)) {
                    //            predicate.value = _.intersection(predicate.value, optionValue).length > 0
                    //                ? predicate.preselectedValues
                    //                : predicate.preselectedValues.concat(optionValue);
                    //        }
                    //        else {
                    //            var optionValueIndex1 = predicate.value.indexOf(optionValue);
                    //            if (optionValueIndex1 === -1) {
                    //                predicate.value = angular.copy(predicate.preselectedValues);
                    //                predicate.value.push(optionValue);
                    //            } else {
                    //                predicate.value = angular.copy(predicate.preselectedValues);
                    //            }
                    //        }
                    //    }
                    //}
                    //else {
                    //    predicate.value = predicate.value === optionValue
                    //    ? null
                    //    : optionValue;
                    //}
                }

                scope.retreatStep = function (stepIndex) {
                    var wizardStep = scope.searchConfiguration.WizardSteps[stepIndex];
                    if (wizardStep) {
                        wizardStep.predicate = {
                            fieldName: wizardStep.SearchFieldName,
                            details: angular.copy(scope.queryModel.predicates[wizardStep.SearchFieldName])
                        };
                    }

                    scope.currentWizardStep = scope.queryModel.isWizardComplete
                        ? scope.lastStepBeforeCompletion
                        : scope.searchConfiguration.WizardSteps[stepIndex].PreviousStepIndex;

                    scope.showResults = false;
                    scope.queryModel.isWizardComplete = false;
                }

                scope.advanceStep = function (stepIndex, stepsToAdvance) {
                    var wizardStep = scope.searchConfiguration.WizardSteps[stepIndex];
                    wizardStep.predicate = {
                        fieldName: wizardStep.SearchFieldName,
                        details: angular.copy(scope.queryModel.predicates[wizardStep.SearchFieldName])
                    };

                    var wizardStepOptions = wizardStep.Options;
                    var stepHasMultipleOptionsSelected =
                        wizardStepOptions.filter(function (option) {
                            return option.IsSelected;
                        }).length > 1;

                    var stepsToAdvanceValue = stepsToAdvance ||
                        stepHasMultipleOptionsSelected
                        ? _.min(scope.searchConfiguration.WizardSteps[stepIndex].Options.map(function (option) {
                            return option.StepsToAdvance;
                        }))
                        : wizardStepOptions.find(function (option) { return option.IsSelected; }).StepsToAdvance;

                    scope.searchConfiguration.WizardSteps[stepIndex].Completed = true;

                    if (scope.searchConfiguration.WizardSteps.length > stepIndex + stepsToAdvanceValue) {
                        scope.currentWizardStep = stepIndex + stepsToAdvanceValue;
                        scope.searchConfiguration.WizardSteps[stepIndex + stepsToAdvanceValue].PreviousStepIndex = stepIndex;
                    }
                    else {
                        scope.showResults = scope.searchConfiguration.WizardSteps[scope.currentWizardStep].Completed;
                        scope.currentWizardStep = scope.searchConfiguration.WizardSteps.length - 1;
                        scope.queryModel.isWizardComplete = true;
                        scope.lastStepBeforeCompletion = stepIndex;
                    }
                }

                scope.stepValueIsSelected = function (stepIndex, optionIndex) {
                    var predicate = scope.queryModel.predicates[scope.searchConfiguration.WizardSteps[stepIndex].SearchFieldName];
                    var optionValue = scope.searchConfiguration.WizardSteps[stepIndex].Options[optionIndex].Value;

                    // this will come later with multi select options in wizards
                    if (Array.isArray(predicate.value)) {
                        if (Array.isArray(optionValue)) {
                            return _.intersection(predicate.value, optionValue).length > 0;
                        }
                        return predicate.value.indexOf(optionValue) !== -1;
                    }

                    return predicate.value === optionValue;
                }

                scope.stepHasSelectedValue = function (stepIndex) {
                    var predicate = scope.queryModel.predicates[scope.searchConfiguration.WizardSteps[stepIndex].SearchFieldName];
                    var value = scope.queryModel.predicates[scope.searchConfiguration.WizardSteps[stepIndex].SearchFieldName].value;

                    if (Array.isArray(value)) {
                        var selectedOption = scope.searchConfiguration.WizardSteps[stepIndex].Options.find(function (option) {
                            return option.IsSelected;
                        });

                        if (selectedOption)
                            return true;

                        return false;
                    }

                    return value !== null;
                }

                scope.hasResults = false;

                scope.$watch(function () { return scope.queryModel; },
                    function () {
                        if (scope.queryModel.isWizardComplete && !scope.hasResults) {
                            scope.hasResults = true;
                            getSearchResults(scope.queryModel);
                        } else {
                            scope.hasResults = false;
                        }
                    }, true);

                $rootScope.$on('pageIndexChanged', function (event, args) {
                    if (args.searchControlId === scope.searchControlId) {
                        scope.queryModel.pageNum = args.pageIndex;
                    }
                });

                $rootScope.$on('pageSizeChanged', function (event, args) {
                    if (args.searchControlId === scope.searchControlId) {
                        scope.queryModel.pageSize = args.pageSize;
                        scope.queryModel.pageNum = args.pageIndex;
                    }
                });

                function getSearchResults() {
                    searchDataService.getResults(scope.queryModel).then(function (data) {
                        scope.results = data.Results;
                        scope.totalItems = data.TotalResults;
                        $rootScope.$emit('searchResultsChanged', {
                            searchControlId: scope.searchControlId,
                            results: scope.results,
                            totalItems: scope.totalItems
                        });
                    });

                    scope.attributes = searchService.getAttributes(scope.queryModel.predicates);
                }
            }
        };
    }

    wizardSearch.$inject = ['$rootScope', 'searchDataService', 'searchService'];

    angular.module('ecap.common').directive('wizardSearch', wizardSearch);
})();